import type { HttpGet } from '@/shared/infra/http'
import type {
  LoadEffectiveTimeBlocks,
  LoadEffectiveTimeBlocksResult,
} from '@/shared/domain'

export class EdgeLoadEffectiveTimeBlocksRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadEffectiveTimeBlocks = async (params) => {
    const huntTypeQuery =
      params.huntType === undefined ? '' : `&huntType=${params.huntType}`
    const locationQuery =
      params.locationType === undefined || params.locationId === undefined
        ? ''
        : `&locationType=${params.locationType}&locationId=${params.locationId}`
    const query = `?orgId=${params.orgId}&orgType=${params.orgType}${huntTypeQuery}${locationQuery}`
    return this.httpClient.get<LoadEffectiveTimeBlocksResult>({
      url: `/org-settings/time-blocks/effective${query}`,
    })
  }
}
